import { ReactComponent as SvgArrow } from '@img/icons/nav-arrow-down.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './LinkList.styles';
const LinkList = ({ active, desktopView = 'list', header, links, onClick, }) => {
    return (React.createElement(S.Container, { "data-view": desktopView, "data-open": active },
        React.createElement(S.ListHeader, { onClick: onClick },
            header,
            " ",
            React.createElement(SvgArrow, null)),
        React.createElement(S.List, null, links.map((link, i) => (React.createElement(S.ListItem, { key: `${header.replace(' ', '-').toLowerCase()}-footer-link-${i}` },
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.ListLink, { href: link.url, target: link.target }, link.text))))))));
};
export default LinkList;
